import refs from '../helpers/refs'

class CInstructionManualCategory {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)
    // All category cards for easy access
    this.allCategoryNodes = []
    // Category + subcategory card data
    this.categories = {
      level: -1,
      children: [],
      title: 'Products',
      path: 'Products'
    }
    this.currentCategory = this.categories

    this.init()
  }

  init () {
    // Init root category node
    this.initNode(this.categories)

    // One-time intialization of nested categories
    // This is a performance optimization to avoid a redundant querySelectorAll calls on each click
    const buildOut = (node = this.categories) => {
      const newLevel = node.level + 1
      const children = this.$root.querySelectorAll(`[data-parent-title="${node.title}"][data-level="${newLevel}"]`)

      for (const cardElem of children) {
        const title = cardElem.dataset.title

        // Create object for this.categories
        const childNode = {
          title,
          element: cardElem,
          level: newLevel,
          path: `${node.path}/${title}`,
          children: [],
          parent: node
        }
        node.children.push(childNode)

        this.initNode(childNode, node)

        // Continue recursion on child nodes
        buildOut(childNode)
      }
    }

    // Run recursion on child nodes of the root node, this.categories
    buildOut()

    // Back button
    this.$refs.backButton.addEventListener('click', () => {
      this.currentCategory.parent.showThisCategory()

      // Hide back button if at root
      if (this.currentCategory.parent === this.categories) {
        this.$refs.backButton.classList.add('hidden')
      }
    })

    // Make the breadcrumbs clickable
    this.updatePathUI()
  }

  initNode (node, parentNode) {
    // Show this catogory card
    node.showThisCategory = () => {
      // Hide all category cards
      this.allCategoryNodes.forEach(childNode => childNode.element.classList.add('hidden'))

      // Show child category cards
      node.children.forEach(childNode => childNode.element.classList.remove('hidden'))

      this.currentCategory = node

      this.updatePathUI()
      this.updateButtonUI()
    }

    // Show card subcategories
    node.showSubCategories = () => {
      // Check if there are subcategories
      if (node.children.length > 0) {
        // Hide parent category cards
        node.parent.children.forEach(node => node.element.classList.add('hidden'))

        // Show child category cards
        for (const subCategory of node.children) {
          subCategory.element.classList.remove('hidden')
        }

        this.currentCategory = node

        this.updatePathUI()
        this.updateButtonUI()
      } else {
        // If there are no subcategories, show the product list
        this.showProductList(node)
      }
    }

    // Category card on click behavior
    if (parentNode) {
      node.element.addEventListener('click', () => {
        node.showSubCategories()
      })
    }

    // Path click behavior
    this.$root.addEventListener(`showCategory:${node.path}`, () => {
      node.showThisCategory()
    })

    // Put all cards in an array for easy access
    if (parentNode) {
      this.allCategoryNodes.push(node)
    }
  }

  showProductList (card) {
    // Tell Vue app to run a search on this category
    document.dispatchEvent(new CustomEvent('categorySearch', { detail: { searchInput: card.title } }))
    // Scroll to search results
    document.querySelector('#manuals-search').scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  jumpTo (path) {
    // Create custom event
    const event = new CustomEvent(`showCategory:${path}`)

    // Dispatch event
    this.$root.dispatchEvent(event)
  }

  updatePathUI () {
    // Clear container
    this.$refs.pathContainer.innerHTML = ''
    const path = this.currentCategory.path.split('/')

    for (let level = 0; level < path.length; level++) {
      // Create path element
      const newElement = document.createElement('span')
      newElement.classList = 'text-label-1 font-bold'
      newElement.textContent = path[level]

      // Make paths clickable (except last one)
      if (level < path.length - 1) {
        newElement.classList += ' cursor-pointer border-b-2 border-grey-800 hover:text-brand hover:border-brand'
        newElement.addEventListener('click', () => {
          this.jumpTo(path.slice(0, level + 1).join('/'))
        })
      }

      this.$refs.pathContainer.appendChild(newElement)

      // Add separator
      if (path.length === 1 || level < path.length - 1) {
        const newElement = document.createElement('span')
        newElement.classList = 'mx-1 text-label-1 font-bold'
        newElement.textContent = ' / '

        this.$refs.pathContainer.appendChild(newElement)
      }
    }
  }

  updateButtonUI () {
    if (this.currentCategory === this.categories) {
      this.$refs.backButton.classList.add('hidden')
    } else {
      this.$refs.backButton.classList.remove('hidden')
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.c-instruction-manual-category')
    .forEach(el => new CInstructionManualCategory(el))
})
